import { usePageviewTrack } from "@app/shared/planhat";
import { currentUserAtom } from "@app/store/userStore";
import { Icon } from "@design-system/Icon";
import { Box } from "@design-system/Layout/Box";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { PageContainer } from "@design-system/Layout/PageContainer";
import { Text } from "@design-system/Typography/Text";
import { UserRole } from "@generated/client/graphql";
import { useAtomValue } from "jotai";
import { type FC } from "react";
import { Navigate } from "react-router-dom";
import { CreateQuestionnaireFromUploadModal } from "../ExternalQuestionnaires/components/QuestionnairesDashboard/CreateQuestionnaireFromUploadModal";
import { AgentCard } from "./components/AgentCard";
import { useAgentsTranslations } from "./i18n";
import { agentName } from "./types";

export const AgentList: FC = () => {
    const currentUser = useAtomValue(currentUserAtom);
    const role = currentUser?.data?.currentUser?.permission?.role;
    const name = currentUser?.data?.currentUser?.firstName;
    const { t, keys } = useAgentsTranslations();

    usePageviewTrack("pageview_dashboard");

    if (role === UserRole.Contributor) {
        return <Navigate to="reporting/overview" />;
    } else {
        return (
            <PageContainer gap="9" py="6" px="4" pb="20">
                <FlexCol gap="6" className="max-w-[900px]" m="auto" pb="20">
                    <FlexCol
                        gap="1.5"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Text variant="hero6">
                            {t(keys.configuration_hi, {
                                name: name,
                            })}
                        </Text>
                        <FlexRow gap="1.5" alignItems="center">
                            <Icon name="stars" className="text-accent-1-300" />
                            <Text variant="body-lg">
                                {t(keys.configuration_how_can_help)}
                            </Text>
                        </FlexRow>
                    </FlexCol>
                    <Box className="grid grid-cols-3 gap-4 w-fit mx-auto justify-center">
                        {Object.values(agentName).map((agent) =>
                            agent === agentName.questionnaire_uploader ? (
                                <CreateQuestionnaireFromUploadModal key={agent}>
                                    <AgentCard agent={agent} />
                                </CreateQuestionnaireFromUploadModal>
                            ) : (
                                <AgentCard key={agent} agent={agent} />
                            ),
                        )}
                    </Box>
                </FlexCol>
            </PageContainer>
        );
    }
};
